import { Typography, Divider as AntdDivider } from 'antd';
import styled from 'styled-components';

const { Text } = Typography;

export const PlaceholderText = styled(Text).attrs({
  type: 'secondary',
  className: 'sf-placeholder-text',
})`
  color: var(--gray-50);
`;

export const Divider = styled(AntdDivider)`
  margin: 0;
`;
